module.exports = __webpack_public_path__ + "static/img/img_a.8b056915.png";